/* Balmohk · Compra rápida (snippets/bm-quick-add-template): el «+» (data-bm-quick-add-open) abre las tallas del
   producto de su tarjeta (data-bm-quick-card, con la foto en data-bm-quick-media); al elegir una se agrega con el
   formulario de Horizon y, confirmado el agregado, se abre el carrito lateral. Tarjetas: la card
   (snippets/bm-product-card) y «Completa el look» de la ficha (snippets/bm-pdp-look-item).
   La cargan todas las secciones con tarjetas: listado, destacados, buscador (panel del header y /search), ficha y sus
   rieles, carrito y Shop the look. El panel del header está en todas las páginas, así que también sirve a las cards
   que llegan después por fetch (recomendados). Un solo juego de listeners por página (window.bmQuickAdd).
   - Mobile (Figma 54:4921): hoja que sube desde abajo (dialog #BmQuickAdd; si la página no lo trae, se crea).
   - Desktop (Figma 2044:1819): panel blanco sobre el pie de la foto; otro clic en el «+», Escape, un clic afuera
     (QA listado-22) o sacar el mouse de la tarjeta (QA dm55-plp-grilla-12) lo cierran.
   La talla → variante (data-variant-id al input «id») también la usa el modal del look (bm-shop-the-look). */
(function () {
  if (window.bmQuickAdd) return;
  window.bmQuickAdd = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  /** «+» que abrió la hoja mobile: dice de qué card (y de qué diálogo, como el buscador) salió el agregado */
  /** @type {Element | null} */
  let sheetPlus = null;

  const CARD = '[data-bm-quick-card]';

  /** Nombre del producto para el aria-label de la hoja o el panel */
  const titleOf = (/** @type {Element} */ card) =>
    card.querySelector('.bm-card__link')?.textContent.trim() ||
    card.querySelector('[data-bm-quick-media]')?.getAttribute('aria-label') ||
    '';

  /** @returns {HTMLDialogElement} */
  const getDialog = () => {
    const existing = document.getElementById('BmQuickAdd');
    if (existing instanceof HTMLDialogElement) return existing;
    const dialog = document.createElement('dialog');
    dialog.id = 'BmQuickAdd';
    dialog.className = 'bm-quick-add';
    const body = document.createElement('div');
    body.className = 'bm-quick-add__body';
    body.setAttribute('data-bm-quick-add-body', '');
    dialog.append(body);
    document.body.append(dialog);
    return dialog;
  };

  /* Mobile: la hoja con las tallas */
  document.addEventListener('click', (event) => {
    const plus = event.target instanceof Element ? event.target.closest('[data-bm-quick-add-open]') : null;
    if (!plus || !mobileQuery.matches) return;
    const card = plus.closest(CARD);
    const template = card?.querySelector('template[data-bm-quick-add]');
    if (!template) return;
    const dialog = getDialog();
    const body = dialog.querySelector('[data-bm-quick-add-body]');
    if (!body) return;
    event.preventDefault();
    body.replaceChildren(template.content.cloneNode(true));
    dialog.setAttribute('aria-label', titleOf(card));
    sheetPlus = plus;
    if (!dialog.open) dialog.showModal();
  });

  /* Desktop: el panel sobre el pie de la foto */
  const closePanels = (except) => {
    document.querySelectorAll('.bm-card__quick:not([hidden])').forEach((panel) => {
      if (panel === except) return;
      panel.hidden = true;
      panel.closest(CARD)?.querySelector('[data-bm-quick-add-open]')?.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const plus = event.target instanceof Element ? event.target.closest('[data-bm-quick-add-open]') : null;
    if (!plus || mobileQuery.matches) return;
    const card = plus.closest(CARD);
    const template = card?.querySelector('template[data-bm-quick-add]');
    const media = card?.querySelector('[data-bm-quick-media]');
    if (!template || !media) return;
    event.preventDefault();
    let panel = card.querySelector('.bm-card__quick');
    if (panel && !panel.hidden) {
      closePanels();
      return;
    }
    closePanels();
    /* Se rearma en cada apertura: el de un envío anterior queda oculto hasta acá, no se saca mientras Horizon lo usa */
    panel?.remove();
    panel = document.createElement('div');
    panel.className = 'bm-card__quick';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', titleOf(card));
    panel.append(template.content.cloneNode(true));
    /* Apoyado en el pie de la foto y, con muchas tallas o una foto chica (el look, de 180), sin pasarse de ella:
       scroll adentro */
    panel.style.setProperty('--bm-quick-bottom', `${media.offsetTop + media.offsetHeight}px`);
    panel.style.setProperty('--bm-quick-max', `${media.offsetHeight}px`);
    media.after(panel);
    plus.setAttribute('aria-expanded', 'true');
    panel.querySelector('.bm-quick-add__size:not(:disabled)')?.focus({ preventScroll: true });
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.bm-card__quick, [data-bm-quick-add-open]')) return;
    closePanels();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.bm-card__quick:not([hidden])');
    if (!open) return;
    closePanels();
    open.closest(CARD)?.querySelector('[data-bm-quick-add-open]')?.focus({ preventScroll: true });
  });
  /* Con el mouse, sacarlo de la tarjeta cierra su panel (QA dm55-plp-grilla-12). pointerleave no burbujea: se
     escucha en captura. Si el foco estaba en una talla vuelve al «+», así no se pierde al esconder el panel */
  document.addEventListener(
    'pointerleave',
    (event) => {
      if (event.pointerType !== 'mouse' || mobileQuery.matches) return;
      const card = event.target instanceof Element && event.target.matches(CARD) ? event.target : null;
      const panel = card?.querySelector('.bm-card__quick:not([hidden])');
      if (!panel) return;
      if (panel.contains(document.activeElement)) {
        card.querySelector('[data-bm-quick-add-open]')?.focus({ preventScroll: true });
      }
      closePanels();
    },
    true
  );
  mobileQuery.addEventListener('change', () => closePanels());

  /* Delegado en document: el morph de Horizon al filtrar puede cambiar el dialog */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const quickAdd = event.target.closest('#BmQuickAdd');
    if (quickAdd instanceof HTMLDialogElement && event.target === quickAdd) {
      quickAdd.close();
      return;
    }
    /* Talla elegida → variante del formulario, antes del submit */
    const size = event.target.closest('.bm-quick-add__size[data-variant-id], .bm-look__size[data-variant-id]');
    const input = size?.closest('product-form-component')?.querySelector('input[name="id"]');
    if (size instanceof HTMLElement && input instanceof HTMLInputElement) input.value = size.dataset.variantId || input.value;
  });

  /* Horizon ya tomó el envío (listener en captura): se cierra la hoja o el panel y, con el agregado confirmado, se
     abre el carrito (abajo). En desktop el foco vuelve al «+» antes de esconder el panel: theme-drawer lo toma como
     disparador y lo devuelve ahí al cerrar el carrito.
     También en captura: en el panel del buscador la card está dentro del <form> de la búsqueda y Chrome corta en ese
     form el «submit» que viene de un form de adentro (no burbujea hasta document); el panel quedaba abierto */
  document.addEventListener('submit', (event) => {
    const quickAdd = event.target instanceof Element ? event.target.closest('#BmQuickAdd') : null;
    if (quickAdd instanceof HTMLDialogElement) setTimeout(() => quickAdd.close());
    const panel = event.target instanceof Element ? event.target.closest('.bm-card__quick') : null;
    if (panel) {
      setTimeout(() => {
        panel.closest(CARD)?.querySelector('[data-bm-quick-add-open]')?.focus({ preventScroll: true });
        closePanels();
      });
    }
  }, true);

  /* Agregado confirmado → carrito lateral con el producto, el mismo camino que la ficha (bm-product.js) y Shop the
     look. Antes sólo cambiaba el contador del header: «Abrir el carrito al agregar» de Horizon está apagado en este
     tema (prueba funcional, compra rápida del listado). Sin cajón: en la página del carrito no se hace nada (la página
     se re-dibuja sola con el producto); en otra, se va a esa página. El cajón no se reabre al navegar: no-persist
     (snippets/cart-drawer). */
  const wait = (/** @type {number} */ ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const openCart = () => {
    const drawer = /** @type {any} */ (document.getElementById('cart-drawer'));
    if (drawer && typeof drawer.open === 'function') {
      if (!drawer.isOpen) drawer.open();
      return;
    }
    if (document.querySelector('cart-items-component')) return;
    /* global Theme: const de snippets/scripts (no cuelga de window) */
    const cartUrl = typeof Theme !== 'undefined' ? Theme.routes?.cart_url : '';
    window.location.assign(cartUrl || '/cart');
  };

  /* El cajón se re-dibuja con la respuesta del agregado (cart-items-component, con una transición de vista si estaba
     vacío): se espera a que tenga la línea de la variante y a que termine la transición, con tope, para abrirlo con el
     producto adentro y no vacío (como #cartReady de bm-product.js) */
  const cartReady = async (/** @type {string} */ variantId) => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !variantId) return;
    const limit = performance.now() + 1500;
    while (!drawer.querySelector(`[data-key^="${variantId}:"]`) && performance.now() < limit) await wait(30);
    const utilities = await import('@theme/utilities').catch(() => null);
    const transition = utilities?.viewTransition?.current;
    if (transition) await Promise.race([transition, wait(1000)]);
  };

  /* Card dentro de un diálogo de Horizon (el panel del buscador, modal): en desktop el cajón abre sin modal (theme-drawer
     desde 990) y quedaba detrás del buscador. Se cierra el diálogo y recién ahí se abre el carrito, en mobile también,
     así al cerrar el carrito se vuelve a la página y no al buscador */
  const closeHost = async (/** @type {Element | null | undefined} */ origin) => {
    const host = /** @type {any} */ (origin?.closest('dialog-component'));
    if (host && typeof host.closeDialog === 'function') await host.closeDialog();
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const { action, promise } = /** @type {any} */ (event);
    const source = event.target instanceof Element ? event.target.closest('#BmQuickAdd, .bm-card__quick') : null;
    if (!source || action !== 'add' || !promise) return;
    const variantId = source.querySelector('input[name="id"]')?.value || '';
    const origin = source instanceof HTMLDialogElement ? sheetPlus : source;
    promise
      .then(async (/** @type {any} */ result) => {
        if (result?.detail?.didError) return;
        await cartReady(variantId);
        /* Mobile: la hoja es un dialog modal; el carrito se abre cuando termina de cerrarse, así su foco vuelve al «+» */
        if (source instanceof HTMLDialogElement && source.open) {
          source.addEventListener('close', () => closeHost(origin).then(openCart), { once: true });
          return;
        }
        await closeHost(origin);
        openCart();
      })
      .catch(() => {});
  });
})();
